import React, { SVGProps } from "react";

const ExpandOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.99984 6.00008L2.6665 2.66675M2.6665 2.66675V5.33342M2.6665 2.66675H5.33317M9.99984 6.00008L13.3332 2.66675M13.3332 2.66675V5.33342M13.3332 2.66675H10.6665M5.99984 10.0001L2.6665 13.3334M2.6665 13.3334V10.6667M2.6665 13.3334H5.33317M9.99984 10.0001L13.3332 13.3334M13.3332 13.3334V10.6667M13.3332 13.3334H10.6665"
      stroke="black"
      stroke-width="0.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default ExpandOutline;
